import { z } from 'zod';

export const WizSelectableObjectTypeSchema = z.enum(['CLOUD_RESOURCE']);

export const WizSelectableObjectCodeRepositorySchema = z.object({
  id: z.string().min(1),
  name: z.string().min(1),
  type: z.string().min(1).nullable().optional(),
  providerUniqueId: z.string().min(1).nullable().optional(),
  url: z.string().min(1).nullable().optional(),
  platform: z.string().min(1).nullable().optional(),
  organizationName: z.string().min(1).nullable().optional(),
});

export const WizSelectableObjectRepositorySchema =
  WizSelectableObjectCodeRepositorySchema;

export const WizSelectableObjectSchema = z.object({
  id: z.string().min(1),
  objectType: WizSelectableObjectTypeSchema,
  type: z.string().min(1),
  externalId: z.string().min(1).nullable(),
  providerUniqueId: z.string().min(1).nullable(),
  name: z.string().min(1),
  nativeType: z.string().min(1),
  cloudPlatform: z.string().min(1).nullable(),
  codeRepository: WizSelectableObjectCodeRepositorySchema.nullable().optional(),
});

export const WIZ_SELECTABLE_OBJECTS_DEFAULT_LIMIT = 500;
export const WIZ_SELECTABLE_OBJECTS_MAX_LIMIT = 500;

export const WizSelectableObjectsQuerySchema = z.object({
  search: z.string().trim().optional(),
  cursor: z.string().optional(),
  limit: z.coerce
    .number()
    .int()
    .positive()
    .max(WIZ_SELECTABLE_OBJECTS_MAX_LIMIT)
    .optional(),
});

export const WizSelectableObjectsResponseSchema = z.object({
  items: z.array(WizSelectableObjectSchema),
  nextCursor: z.string().nullable(),
});

export const WizApplicationMappingSchema = z.object({
  applicationId: z.string().min(1),
  object: WizSelectableObjectSchema,
});

export const WizApplicationMappingsSchema = z.array(
  WizApplicationMappingSchema,
);

export type WizApplicationMapping = z.infer<typeof WizApplicationMappingSchema>;
export type WizSelectableObject = z.infer<typeof WizSelectableObjectSchema>;
export type WizSelectableObjectCodeRepository = z.infer<
  typeof WizSelectableObjectCodeRepositorySchema
>;
export type WizSelectableObjectRepository = WizSelectableObjectCodeRepository;
export type WizSelectableObjectType = z.infer<
  typeof WizSelectableObjectTypeSchema
>;
